// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"271":"113db7589ca3225e","384":"390d5d821eb27fc9","757":"75c5c2b70a26e815"}[chunkId] + ".js";
};